import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { OrderFillsCapsuleWidgetType } from 'widgets/venueAnalysis/capsules/orderFillsCapsulesShared/types/OrderFillsCapsuleWidgetType';

export const selectOrderFillsCapsulesState = (
    state: State,
    widgetType: OrderFillsCapsuleWidgetType
) => selectWidgetInstancesState(state)[widgetType];

export const selectOrderFillsCapsuleState =
    (widgetType: OrderFillsCapsuleWidgetType) =>
    (
        state: State,

        widgetKey: string
    ) =>
        selectOrderFillsCapsulesState(state, widgetType)[widgetKey];
